import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';
import { AvatarUpload } from './AvatarUpload';

export interface ProfileAvatarDialogProps {
  open: boolean;
  onClose: () => void;
}

/**
 * Self-service "profile picture" dialog (AC-23/R1). Hosts the shared
 * AvatarUpload in `self` mode and refreshes the signed-in user afterwards so
 * the change is reflected immediately (TopBar / account sheet). This is the
 * profile-settings home for the self avatar — reachable from the account menu.
 */
export function ProfileAvatarDialog({ open, onClose }: ProfileAvatarDialogProps) {
  const { user, refreshUser } = useAuth();
  const name = [user?.firstName, user?.lastName].filter(Boolean).join(' ') || user?.email || '';

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Profile picture</DialogTitle>
      <DialogContent>
        <AvatarUpload
          name={name}
          avatarUrl={user?.avatarUrl}
          target={{ kind: 'self' }}
          onChange={() => {
            void refreshUser();
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Done</Button>
      </DialogActions>
    </Dialog>
  );
}

export default ProfileAvatarDialog;
